export enum RedirectLinkType {
  Subdomain,
  Query,
  Domain,
}
